import { Row ,Container, Col } from "react-bootstrap";
import classes from "./CustomerRelationsComponent.module.scss"
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import RemoveIcon from '@mui/icons-material/Remove';
import { ClientTypes, CustomerRelations } from "../../../store/orgId_context";

const Relation = ({relation ,relationTitle, active, children, icon, onActivateClick}) =>{
    const cirbledBIcon = <FormatBoldIcon style={{backgroundColor:"#2196f3", borderRadius:"50%"}}/>

    
    return (
        <>
        <Container className={`${classes["relationContainer"]} d-flex flex-column`} style={{height:"100%"}} active={active} onClick={() => onActivateClick(relation)}>
            <Row className={classes["titleRow"]}>
                <Col className="col-md-2">{icon}</Col>
                <Col className="col-md-8" style={{textAlign:"center"}}>
                    <div className={classes["titleBadge"]}>{relationTitle}</div>
                </Col>
                <Col className="col-md-2" style={{paddingLeft:"0px"}}>
                    {active==="true" &&  <DoneAllIcon style={{color:"#15d715"}}/>}
                </Col>
            </Row>
            <Row style={{padding:"0.5rem"}}>
                {children}
            </Row>
            <Row className={`${classes["bottomRow"]} mt-auto`} style={{textAlign:"center", padding:"1rem"}}>
                <Col>
                {CustomerRelations.None===relation && cirbledBIcon}
                {CustomerRelations.AdminByCustomer===relation && 
                <>
                <FormatBoldIcon/><RemoveIcon/>{cirbledBIcon}
                </>}
                {CustomerRelations.SupportByDDD===relation && 
                <>
                <FormatBoldIcon/><RemoveIcon/>{cirbledBIcon}<RemoveIcon/><FormatBoldIcon/>
                </>}
                {CustomerRelations.EIOL===relation && cirbledBIcon}
                </Col>
            </Row>
        </Container>
        </>
    )
}

export default Relation;